
import Vue from "vue";
import { HTTP } from '@/axios_api/http-common';
import * as XLSX from 'xlsx';
export default Vue.extend({
    props: ["height", "selectedProjectId", "activityOptions"],
    data() {
        return {
            activityTimeData: { tableId: '', columns: [] } as { tableId: '', columns: { columnName: string; values: string[] }[] },
            search: "",
            actionFilter: "All",
            categoryFilter: "All",
            fields: [
                { key: 'Name', label: 'Activity' },
                { key: 'Duration', label: 'Plan Time (Days)', class: 'text-center' },
                { key: 'ActualDuration', label: 'Actual Time (Days)', class: 'text-center' },
            ],
        }
    },
    computed: {
        computedTableData(): Array<any> {
            if (this.activityTimeData.columns.length) {
                let arr = [];
                for (let i = 0; i < this.activityTimeData.columns[0].values.length; i++) {
                    // if (i === 0) continue;
                    arr.push({
                        Name: this.activityTimeData.columns[0].values[i],
                        Duration: this.activityTimeData.columns[1].values[i],
                        ActualDuration: this.activityTimeData.columns[2].values[i],
                    })
                }
                return arr
            }

            return []
        },

        getHeader(): string {
            return "Activity Time Table for " + this.getProjectNameFromId(this.selectedProjectId)
        }
    },
    methods: {
        exportToExcel() {
            const exportData = this.computedTableData.map(row => ({
                "Activity": row.Name,
                "Plan Time (Days)": row.Duration,
                "Actual Time (Days)": row.ActualDuration
            }));

            const ws = XLSX.utils.json_to_sheet(exportData);

            // Calculate column widths based on data
            type ExportDataKey = "Activity" | "Plan Time (Days)" | "Actual Time (Days)";
            const columnWidths = Object.keys(exportData[0] || {}).map(key => {
                const typedKey = key as ExportDataKey;
                const maxLength = Math.max(
                key.length,
                ...exportData.map(row => (row[typedKey] ? String(row[typedKey]).length : 0))
                );
                return { wch: maxLength + 2 }; // Add some padding
            });

            // Apply column width
            ws['!cols'] = columnWidths;

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "ActivityTimeTable");

            const fileName = `Activity_Time_Table_${this.getProjectNameFromId(this.selectedProjectId)}.xlsx`;
            XLSX.writeFile(wb, fileName);
        },
        fetchData() {
            const queryString = this.activityOptions.map((activity: any) => `ActivityIds=${activity.value}`).join('&');
            HTTP.get(`analytics/query/activitytime/?projectId=${this.selectedProjectId}&${queryString}`)
                .then((response: any) => {
                    this.activityTimeData = response.data.data
                })
                .catch((error: any) => {

                })
        },

        getProjectNameFromId(id: any) {
            const project = this.$store.getters["projectModule/getProjectById"](id);
            return project && project.name ? project.name : "";
        },
    },
    mounted() {
        this.fetchData()
    },
    watch: {
        activityTimeData: {
            handler() {
                if (!this.activityTimeData.columns.length) {
                    this.fetchData()
                }
            }
        }
    }
})
